import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DocumentLibraryConstants } from '../../../document-library-constants';
import { DocumentService } from '../../../services/document.service';
import { UsersService } from '../../../../shared/services/users.service';
import { ResponsibleSubBUService } from '../../../../shared/services/responsible-sub-bu.service';
import { Document } from '../../../models/document';
import { DocumentVersion } from '../../../models/documentVersion';
import { Router } from '@angular/router';
import { DocumentDetail } from '../../../models/documentVersionDetail';
import { cloneDeep } from 'lodash-es';
import { DocumentPersistenceService } from '../../../services/document-persistence.service';
import { SliderMenuErrorMessageDto } from '../../../models/slider-menu-error-message-dto';
import { DocumentAttachmentDetails } from '../../../models/document-attachment-details';
import { TreeNodeDto } from '../../../models/tree-node-dto';
import { NameValue } from '../../../../shared/models/name-value';
import { PrimeNGConfig } from 'primeng/api';
import { PhaseValueConstants } from '../../../../shared/constants/phaseValues-constants';
import {
  catchError,
  debounceTime,
  filter,
  firstValueFrom,
  forkJoin,
  of,
  Subject,
  Subscription,
  switchMap,
  take,
} from 'rxjs';
import { AssignmentGroupsRequest } from '../../../models/assignment-groups-request';
import { AssignmentGroupSharedDataService } from '../../../../shared/services/assignment-group-shared-data.service';
import { DocumentMasterDataService } from '../../../services/document-master-data.service';
import { AssignmentDTO } from '../../../../../app/shared/models/Assignment';
import { UserAssignment } from '../../../../shared/models/user-assignment';
import { UserType } from '../../../../../app/shared/enums/user-type';
import { Attachment } from '../../../../document/models/attachment';

@Component({
  selector: 'app-document-general-details',
  templateUrl: './document-general-details.component.html',
  styleUrls: ['./document-general-details.component.scss'],
})
export class DocumentGeneralDetailsComponent implements OnInit, OnDestroy {
  @Output() activateTabIndex = new EventEmitter<number>();
  @Output() enableOtherTabs = new EventEmitter<boolean>();
  private debounceSubject: Subject<void> = new Subject<void>();
  isEditSlider: boolean = false;
  isReasonForDocumentUpdateRequired = false;
  reasonForDocumentUpdate = '';
  documentForm!: FormGroup;
  valueField: string = 'value';
  labelField: string = 'name';
  saveClicked: boolean = false;
  errorMessages: string[] = [];
  saveSuccess: boolean = true;
  documentBindData: any = {};
  serviceDocumentData: any = {};
  assignmentGroupsSubscription: Subscription | undefined;
  documentDetailsSubscription: Subscription | undefined;
  loadDocumentDetailsSubscription: Subscription | undefined;
  editDocumentSliderSubscription: Subscription | undefined;
  userList: any = [];
  usersAndAssignmentGroupList: any = [];
  eQMSScopeList: any = [];
  inactiveAssignments: any = [];
  collaboratorGroupsAndUsersList: any = [];
  assignedAdminGroupsAndUsersList: any = [];
  assignedQAsGroupsAndUsersList: any = [];
  assignedDocControlGroupsAndUsersList: any = [];
  internalClientContactsUsersList: any = [];
  collaboratorUserListWithInactiveUsers: any = [];
  assignedAdminsUserListWithInactiveUsers: any = [];
  periodicReviewersUserListWithInactiveUsers: any = [];
  assignedQAsUserListWithInactiveUsers: any = [];
  assignedDocControlUsersListWithInactiveUsers: any = [];
  internalClientContactsUsersListWithInactiveUsers: any = [];
  reviewersWithInactiveUsers: any = [];
  approversWithInactiveUsers: any = [];
  periodicReviewersGroupsAndUsersList: any = [];
  authorWithInactiveUsers: any = [];
  validatedInactiveUsers: any = [];
  reviewersList: any = [];
  approversList: any = [];
  authorList: any = [];
  assignmentGroups: any;
  sbuList: any = [];
  generalTabloader = false;
  minDateValue: Date = new Date();
  document!: Document;
  isPeriodicReviewCycleIsNA: boolean = false;
  isPeriodicReviewCycleUserDefined: boolean = false;
  isPeriodicReviewCycleNull: boolean = true;
  isReviewerListChanged: boolean = false;
  isApproverListChanged: boolean = false;
  disablePeriodicReviewDate: boolean = false;
  isInActiveAssignmentGroupDialog: boolean = false;
  InactiveAssignmentGroupField = '';
  inactiveGroupsSelected: any;
  isReasonRequired = false;
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  isDocumentSaveInProgress = false;
  stateOptions!: any[];
  iseQMSScopeSelected: boolean = false;
  isAssignedQAsSelected: boolean = false;
  isInternalClientContactsSelected: boolean = false;
  isAssignedQAsValid: boolean = false;
  isIncludesQAReviewSelected: boolean = true;
  isIncludesClientSignatureSelected: boolean = true;
  isAssignedQAsMandatory: boolean = false;
  isInternalClientContactsMandatory: boolean = false;
  documentDetails!: DocumentDetail;
  documentDetailsForEdit!: DocumentDetail;
  documentNumber!: string;
  isEffectiveVersionLabelDisabled: boolean = false;
  isRequestEffectiveDateEditable: boolean = true;
  isEffectiveVersionHide: boolean = false;
  excludedPhasesForHide: number[] = [5, 6];
  isLatestDocument: boolean = false;
  version!: number;
  isEffective!: boolean;
  isAssignedQAControlEnabled: boolean = true;
  isInternalClientContactControlEnabled: boolean = false;
  validationErrorEnable: boolean = false;
  isPeriodicReviewerMandatory: boolean = false;
  isPeriodicReviewerRequired = false;
  documentSaveProgressMessage =
    DocumentLibraryConstants.Document_Save_InProgress;
  readonly infoForIncludeQAReview: string =
    DocumentLibraryConstants.Info_For_IncludeQAReview_Text;
  readonly infoForIncludesClientSignature: string =
    DocumentLibraryConstants.Info_For_IncludesClientContact_Text;
  readonly infoForConvertToPdf: string =
    DocumentLibraryConstants.Info_For_ConvertToPdf_Text;
  readonly infoForMergeClientSignatureAttachment: string =
    DocumentLibraryConstants.Info_For_Merge_ClientSignature_Attachment_Text;
  addEditDocumentFormControlsDisabledByDefault =
    DocumentLibraryConstants.Add_Edit_DocumentFormControls_Disabled_ByDefault;
  addEditDocumentFormControlsEnabledByDefault =
    DocumentLibraryConstants.Add_Edit_DocumentFormDocumentControls_Enabled_ByDefault;
  documentDetailsTabErrorMessage!: SliderMenuErrorMessageDto;
  showDeletedFilesConfirmationModal = false;
  showDeletedClientSignatureAttachmentConfirmationModal = false;
  deletedAttachments: DocumentAttachmentDetails[] = [];
  deleteAttachmentConfirmationMessage: string =
    DocumentLibraryConstants.Deleted_Attachments_Confirmation_Message;
  deleteClientSignatureAttachmentConfirmationMessage: string =
    DocumentLibraryConstants.Deleted_ClientSignatureAttachment_Confirmation_Message;
  isRequestedEffectiveDateToBeDisplayed: boolean = false;
  isRequestedEffectiveDateChanged: boolean = false;
  isEffectiveDateChanged: boolean = false;
  isPeriodicReviewDateChanged: boolean = false;
  deletedClientSignatureAttachment?: Attachment;
  readonly requiredPhasesToCheck = [1, 2, 3, 4];
  readonly documentAssignmentTypes = [ 
    DocumentLibraryConstants.Assignment_types.AssignedAdmins,
    DocumentLibraryConstants.Assignment_types.AssignedDocControl,
    DocumentLibraryConstants.Assignment_types.AssignedQA,
    DocumentLibraryConstants.Assignment_types.Collaborator,
    DocumentLibraryConstants.Assignment_types.PeriodicReviewer
  ];
  scopeList: TreeNodeDto[] = [];
  reasonValidationMessage: string =
    DocumentLibraryConstants.ReasonValidationMessage;
  heading: string = DocumentLibraryConstants.ReasonHeading;
  usersListToValidate: UserAssignment[] = [];
  validatedUsersList: UserAssignment[] = [];
  readonly infoForForbidChangesAfterInReviewTransition: string =
    DocumentLibraryConstants.Info_For_ForbidChangesAfterInReviewTransition_Text;
  isInitialeQMSScopeSelection: boolean = false;
  readonly phasesToDisableForbidChangesAfterInReviewTransition: number[] = [
    3, 4, 5, 10,
  ];
  constructor(
    private primeNGConfig: PrimeNGConfig,
    private _formBuilder: FormBuilder,
    private documentsservice: DocumentService,
    private usersService: UsersService,
    private subBUService: ResponsibleSubBUService,
    private documentMasterDataService: DocumentMasterDataService,
    private router: Router,
    private documentPersistenceService: DocumentPersistenceService,
    private changeDetectorRef: ChangeDetectorRef,
    private assignmentGroupSharedDataService: AssignmentGroupSharedDataService
  ) {}

  initialize() {
    this.documentPersistenceService.linkedDocuments = [];
    this.documentPersistenceService.documentSaveInProgress$.subscribe(
      (documentSaveStatus) => {
        this.isDocumentSaveInProgress = documentSaveStatus;
      }
    );
    this.documentPersistenceService.closeAndResetDocumentSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.closeAndResetDocumentSlider();
        }
      }
    );
    this.documentPersistenceService.currentTabInSliderMenu$.subscribe(
      (tabIndex) => {
        if (
          tabIndex === DocumentLibraryConstants.Document_Menu_General_Tab_Index
        ) {
          this.updateDocumentDetailsOnTabChange();
        }
      }
    );
    this.checkSliderFromDocumentDetails();

    this.getSeedDataAndDocumentsliderData();
  }

  // Fetch the seed data to create document
  // To DO -- Need to fetch the required data only from API (users,subbus,labsites)
  // Update the getSeedDataAndDocumentsliderData method
getSeedDataAndDocumentsliderData() {
  // Load each source with individual fallback to avoid blocking other lookups
  const scopesData$ = this.documentMasterDataService
    .geteQMSScopesForDocument()
    .pipe(
      catchError((err) => {
        console.error('eQMS Scopes Lookup - error while getting data at Web UI', err);
        return of([]);
      })
    );

  const subBUData$ = this.subBUService.getSubBU().pipe(
    catchError((err) => {
      console.error('Sub BU Lookup - error while getting data at Web UI', err);
      return of([]);
    })
  );

  const documentDetails$ = this.documentsservice.getDocumentdetails().pipe(
    catchError((err) => {
      console.error('Document Lookup - error while getting data at Web UI', err);
      return of(null);
    })
  );

  forkJoin({
    scopes: scopesData$,
    subBU: subBUData$,
    documentDetails: documentDetails$
  }).subscribe(({ scopes, subBU, documentDetails }) => {
    // Process eQMS Scopes
    this.eQMSScopeList = [];
    this.scopeList = [];
    for (let dataItem of scopes) {
      this.eQMSScopeList.push({
        value: dataItem.eQMSScopeId,
        name: dataItem.eQMSScopeName,
        forbidChangesForInReviewDocument: dataItem.forbidChangesForInReviewDocument,
        printLockDocuments: dataItem.printLockDocuments
      });
      this.scopeList.push({
        id: dataItem.eQMSScopeId.toString(),
        name: dataItem.eQMSScopeName,
        parentId: '',
      });
    }
    this.documentPersistenceService.updateScopeList(this.scopeList);

    // Process SubBU
    this.sbuList = subBU.map((dataItem: { Code: string; Name: string }) => ({
      value: dataItem.Code + ' ' + dataItem.Name,
      name: `${dataItem.Code} ${dataItem.Name}`,
    }));

    // Process Document Details
    if (documentDetails) {
      this.serviceDocumentData = cloneDeep(documentDetails);
      this.createData();
      this.setDefaultsForDocumentForm();
    }

    // Mark data as loaded
    this.documentsservice.editDocumentMetaDataLoaded$.next(true);
  });
}
// Update the isDocumentMetadataReady method
private isDocumentMetadataReady(): boolean {
  return !!(
    this.documentBindData &&
    this.documentBindData.operationalGroup &&
    this.documentBindData.operationalGroup.length > 0 &&
    this.documentBindData.classificationLevel &&
    this.documentBindData.periodicReviewCycles &&
    this.documentBindData.divisions &&
    this.documentBindData.functionalAreas &&
    this.documentBindData.documentTypes &&
    this.eQMSScopeList && 
    this.eQMSScopeList.length > 0 &&
    this.scopeList &&
    this.scopeList.length > 0
  );
}


  createData() {
    this.documentBindData.phases = this.serviceDocumentData.phases;
    this.documentBindData.confidentialityLevels =
      this.serviceDocumentData.confidentialityLevels;
    this.documentBindData.periodicReviewCycles =
      this.serviceDocumentData.periodicReviewCycles;
    this.documentBindData.categories = this.getListWithNameCodeAsName(
      this.serviceDocumentData.categories
    );
    this.documentBindData.divisions = this.getListWithNameCodeAsName(
      this.serviceDocumentData.divisions
    );
    this.documentBindData.functionalAreas = this.getListWithNameCodeAsName(
      this.serviceDocumentData.functionalAreas
    );
    this.documentBindData.documentTypes = this.getListWithNameCodeAsName(
      this.serviceDocumentData.documentTypes
    );
    this.documentBindData.localLevels = this.serviceDocumentData.localLevels;
    this.documentBindData.localCategories = this.getListWithNameCodeAsName(
      this.serviceDocumentData.localCategories
    );
    this.documentBindData.localTypes = this.serviceDocumentData.localTypes;
    this.documentBindData.securities = this.serviceDocumentData.securities;
    this.documentBindData.classificationLevel =
      this.serviceDocumentData.classificationLevels;
    this.documentBindData.tags = this.serviceDocumentData.tags;
    this.documentBindData.operationalGroup =
      this.serviceDocumentData.operationalGroup;
    this.documentBindData.responsibleSubBusinessUnit = this.sbuList;

    // Mark change detection to ensure view updates with new data
    this.changeDetectorRef.markForCheck();
    
    this.documentsservice.editDocumentMetaDataLoaded$.next(true);
  }

  ngOnInit(): void {
    //Below code is used to wait for subscription and to wait for 5ms to get read the input
    this.debounceSubject.pipe(debounceTime(500)).subscribe(() => {
      this.loadUserList();
      this.ValidateAssignedQAsCheck();
    });

    this.documentForm = this.createFormGroupWithBuilderAndModel();
    //Below method is used to subscribe when there is a value change in eQMS Scope
    this.documentForm.get('eQMSScopes')?.valueChanges.subscribe((newValue) => {
      this.validateeQMSScopes();
    });

    this.disableControls(this.addEditDocumentFormControlsDisabledByDefault);
    this.enableControls(this.addEditDocumentFormControlsEnabledByDefault);

    this.initialize();
    this.onFormControlChanges();
    this.minDateValue.setDate(new Date().getDate() + 1);
    this.primeNGConfig.ripple = true;
    this.editDocumentSliderSubscription = this.documentsservice.editDocumentSlider$.subscribe((isEdit) => {
      if (isEdit) {
        this.isEditSlider = true;
        this.generalTabloader = true;
        this.loadEditDocumentSlider();
      }
    });
  }

  loadEditDocumentSlider() {
    if (this.isEditSlider) {
      this.loadDocumentSliderWithDetails();
      this.documentSaveProgressMessage =
        DocumentLibraryConstants.Document_Update_InProgress;
    }
  }

  ValidateAndDisplayRequestedEffectiveDate() {
    if (
      this.requiredPhasesToCheck.indexOf(this.documentDetailsForEdit?.phase) !==
      -1
    ) {
      this.isRequestedEffectiveDateToBeDisplayed = true;
    } else {
      this.isRequestedEffectiveDateToBeDisplayed = false;
    }
  }
  createFormGroupWithBuilderAndModel() {
    return this._formBuilder.group({
      title: new FormControl('', [Validators.required]),
      legacyDocument: new FormControl(),
      effectiveDate: new FormControl(null),
      periodicReviewCycle: new FormControl(null, [Validators.required]),
      periodicReviewDate: new FormControl(null),
      category: new FormControl(),
      division: new FormControl(null, [Validators.required]),
      functionalArea: new FormControl(null, [Validators.required]),
      documentType: new FormControl(null, [Validators.required]),
      localLevel: new FormControl(),
      localCategory: new FormControl(),
      localType: new FormControl(),
      responsibleSubBusinessUnit: new FormControl(),
      author: new FormControl(null, [Validators.required]),
      assignedAdmins: new FormControl(null, [Validators.required]),
      collaborators: new FormControl(),
      assignedQAs: new FormControl(),
      requestedEffectiveDate: new FormControl(),
      assignedDocControl: new FormControl(null, [Validators.required]),
      confidentialityLevel: new FormControl(1, [Validators.required]),
      reviewers: new FormControl(null, [Validators.required]),
      approvers: new FormControl(null, [Validators.required]),
      periodicReviewers: new FormControl(),
      securityPermissions: new FormControl([22], [Validators.required]),
      classificationLevel: new FormControl(),
      eQMSScopes: new FormControl(null, [Validators.required]),
      includeQAReview: new FormControl(),
      convertToPdf: new FormControl(),
      tags: new FormControl(),
      operationalGroup: new FormControl(null),
      includesClientSignature: new FormControl(),
      internalClientContacts: new FormControl(),
      mergeClientSignatureAttachment: new FormControl(),
      forbidChangesAfterInReviewTransition: new FormControl(false),
      reason: new FormControl(null),
      printLock : new FormControl(false)
    });
  }

  private checkIfAssignedQAIsRequired() {
    this.ValidateIncludeQAReview();
    this.ValidateAssignedQAs();
    if (this.isIncludesQAReviewSelected) {
      if (!this.isAssignedQAsSelected) {
        this.errorMessages.push(
          DocumentLibraryConstants.Document_assignedQAs_Required
        );
        this.isAssignedQAsMandatory = true;
      } else {
        this.isAssignedQAsMandatory = false;
      }
    } else {
      this.isAssignedQAsMandatory = false;
    }
  }
  ValidateIncludeQAReview() {
    this.isIncludesQAReviewSelected =
      this.documentForm.getRawValue().includeQAReview !== undefined &&
      (this.documentForm.getRawValue().includeQAReview === null ||
        this.documentForm.getRawValue().includeQAReview == true);
  }

  ValidateAssignedQAs() {
    this.isAssignedQAsSelected =
      this.documentForm.getRawValue().assignedQAs !== undefined &&
      this.documentForm.getRawValue().assignedQAs !== null &&
      this.documentForm.getRawValue().assignedQAs.length !== 0;
  }

  private checkIfInternalClientContactIsRequired() {
    this.ValidateIncludesClientSignature();
    this.ValidateInternalClientContact();
    if (this.isIncludesClientSignatureSelected) {
      if (!this.isInternalClientContactsSelected) {
        this.errorMessages.push(
          DocumentLibraryConstants.Document_internalClientConact_Required
        );
        this.isInternalClientContactsMandatory = true;
      } else {
        this.isInternalClientContactsMandatory = false;
      }
    } else {
      this.isInternalClientContactsMandatory = false;
    }
  }
  ValidateIncludesClientSignature() {
    this.isIncludesClientSignatureSelected =
      this.documentForm.getRawValue().includesClientSignature !== undefined &&
      this.documentForm.getRawValue().includesClientSignature != null
        ? this.documentForm.getRawValue().includesClientSignature
        : false;
  }

  ValidateInternalClientContact() {
    this.isInternalClientContactsSelected =
      this.documentForm.getRawValue().internalClientContacts !== undefined &&
      this.documentForm.getRawValue().internalClientContacts !== null &&
      this.documentForm.getRawValue().internalClientContacts.length !== 0;
  }

  private checkValidationRules() {
    this.checkIfReviewerAndApproverAreSame();
    this.checkIfPeriodicReviewIsNotApplicable();
    this.checkIfReviewerIsUpdated();
    this.checkIfApproverIsUpdated();
    this.checkIfAssignedQAIsRequired();
    this.checkIfInternalClientContactIsRequired();
  }

  updateDocument() {
    this.saveClicked = true;
    this.validateForm();
    this.checkValidationRules();
    if (this.errorMessages.length === 0) {
      this.documentPersistenceService.updateTabErrorIndex(
        DocumentLibraryConstants.Document_Menu_General_Tab_Index,
        false
      );
      this.deletedAttachments =
        this.documentPersistenceService.deletedDocumentAttachments;
      if (this.deletedAttachments.length > 0) {
        this.showDeletedFilesConfirmationModal = true;
      } else {
        //Reset these values everytime
        this.isReasonRequired = false;
        this.inactiveGroupsSelected = undefined;
        this.isReasonRequired = [
          PhaseValueConstants.InReview,
          PhaseValueConstants.ReadyForApproval,
          PhaseValueConstants.Approved,
          PhaseValueConstants.Effective,
        ].includes(this.documentDetails.phase);
        this.mapDocumentFromToDocument();
        this.inactiveGroupsSelected =
          this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(
            this.document?.documentVersion,
            this.validatedUsersList, this.documentPersistenceService.usersList
          );

        if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } else {
          if (
            this.inactiveGroupsSelected != undefined &&
            this.inactiveGroupsSelected.length > 0
          ) {
            this.isInActiveAssignmentGroupDialog = true;
            this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
          } else {
            this.saveDocument();
          }
        }
      }
    } else {
      if (this.isEditSlider) {
        this.documentPersistenceService.updateTabErrorIndex(
          DocumentLibraryConstants.Document_Menu_General_Tab_Index,
          true
        );
      }
      document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  }

  showConfirmationPopupForDeletedClientSignatureAttachments() {
    this.showDeletedFilesConfirmationModal = false;
    this.deletedClientSignatureAttachment =
      this.documentPersistenceService.deletedClientSignatureAttachment;
    if (this.deletedClientSignatureAttachment != null) {
      this.showDeletedClientSignatureAttachmentConfirmationModal = true;
    } else {
      this.saveDocument();
    }
  }

  updateReasonForEditorSave() {
    [
      PhaseValueConstants.InReview,
      PhaseValueConstants.ReadyForApproval,
      PhaseValueConstants.Approved,
      PhaseValueConstants.Effective,
    ].includes(this.documentDetails.phase) &&
    !this.reasonForDocumentUpdate.length
      ? (this.isReasonForDocumentUpdateRequired = true)
      : this.saveDocument();
  }

  closeReasonDailog(value: boolean) {
    this.isReasonForDocumentUpdateRequired = value;
  }

  saveDocumentwithReason(value: any) {
    this.reasonForDocumentUpdate = value;
    this.isReasonForDocumentUpdateRequired = false;
    if (
      this.inactiveGroupsSelected != undefined &&
      this.inactiveGroupsSelected.length > 0
    ) {
      this.isInActiveAssignmentGroupDialog = true;
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
    } else {
      this.saveDocument();
    }
  }

  closeConfirmationDailog(value: boolean) {
    this.isInActiveAssignmentGroupDialog = value;
  }

  saveDocumentwithInactiveAssignmentGroup() {
    this.isInActiveAssignmentGroupDialog = false;
    this.saveDocument();
  }

  saveDocument = () => {
    this.closeConfirmationModal();
    this.mapDocumentFromToDocument();
    this.documentPersistenceService.updateSaveInProgressStatus(true); // To DO -- Need to create Interceptor to show spinner for all the post requests
    this.documentPersistenceService.updateDocumentDetails(this.document);
    this.documentPersistenceService.updateDocument();
    this.reasonForDocumentUpdate = '';
  };
  closeConfirmationModal = () => {
    this.showDeletedFilesConfirmationModal = false;
  };

  closeConfirmationModalForDeletedClientSignatureAttachments = () => {
    this.showDeletedClientSignatureAttachmentConfirmationModal = false;
  };
  openNextTab = () => {
    this.validateForm();
    this.checkValidationRules();
    if (this.errorMessages.length === 0) {
      if (this.isEditSlider) {
        this.documentPersistenceService.updateTabErrorIndex(
          DocumentLibraryConstants.Document_Menu_General_Tab_Index,
          false
        );
      }
      this.mapDocumentFromToDocument();
      this.documentPersistenceService.updateDocumentDetails(this.document);
      this.activateTabIndex.emit(
        DocumentLibraryConstants.Document_Menu_File_Tab_Index
      );
      this.documentPersistenceService.onCustomTabChange(
        DocumentLibraryConstants.Document_Menu_File_Tab_Index
      );
    } else {
      if (this.isEditSlider) {
        this.mapDocumentFromToDocument();
        this.documentPersistenceService.updateDocumentDetails(this.document);
        this.documentPersistenceService.clientSignatureAttachmentVisibile =
          this.documentDetails.isClientSignatureAttachmentAvailable === null ||
          this.documentDetails.isClientSignatureAttachmentAvailable ===
            undefined
            ? false
            : this.documentDetails.isClientSignatureAttachmentAvailable!;
        this.documentPersistenceService.updateTabErrorIndex(
          DocumentLibraryConstants.Document_Menu_General_Tab_Index,
          true
        );
        this.activateTabIndex.emit(
          DocumentLibraryConstants.Document_Menu_File_Tab_Index
        );
        this.documentPersistenceService.onCustomTabChange(
          DocumentLibraryConstants.Document_Menu_File_Tab_Index
        );
      } else document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  };

  updateDocumentDetailsOnTabChange = () => {
    this.validateForm();
    this.checkValidationRules();
    if (this.errorMessages.length === 0) {
      this.documentPersistenceService.updateTabErrorIndex(
        DocumentLibraryConstants.Document_Menu_General_Tab_Index,
        false
      );
      this.mapDocumentFromToDocument();
      this.documentPersistenceService.updateDocumentDetails(this.document);
    } else {
      if (this.isEditSlider) {
        this.mapDocumentFromToDocument();
        this.documentPersistenceService.updateDocumentDetails(this.document);
        this.documentPersistenceService.clientSignatureAttachmentVisibile =
          this.documentDetails.isClientSignatureAttachmentAvailable === null ||
          this.documentDetails.isClientSignatureAttachmentAvailable ===
            undefined
            ? false
            : this.documentDetails.isClientSignatureAttachmentAvailable!;
      }
      this.documentPersistenceService.updateTabErrorIndex(
        DocumentLibraryConstants.Document_Menu_General_Tab_Index,
        true
      );
      }
  };

  mapDocumentFromToDocument() {
    let formValues = this.documentForm.getRawValue();
    let docDetails: DocumentVersion = {
      title: formValues.title,
      phase:
        this.documentDetails === undefined
          ? DocumentLibraryConstants.Document_Default_DocumentVersion
          : this.documentDetails.phase.toString(),
      version:
        this.documentDetails === undefined
          ? DocumentLibraryConstants.Document_Default_DocumentPhase
          : this.documentDetails.version,
      legacyDocumentNumber: formValues.legacyDocument === '' ? null : formValues.legacyDocument,
      confidentialityLevel: formValues.confidentialityLevel,
      effectiveDate: (formValues.effectiveDate!=null|| formValues.effectiveDate!=undefined) ? this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(formValues.effectiveDate)):undefined,
      periodicReviewCycle: formValues.periodicReviewCycle,
      periodicReviewDate:(formValues.periodicReviewDate!=null || formValues.periodicReviewDate!= undefined) ? this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(formValues.periodicReviewDate)):undefined,
      category: formValues.category,
      division: formValues.division,
      functionalArea: formValues.functionalArea,
      documentType: formValues.documentType,
      localLevel: formValues.localLevel,
      localCategory: formValues.localCategory,
      localType: formValues.localType,
      responsibleSubBusinessUnit: formValues.responsibleSubBusinessUnit,
      author: formValues.author,
      assignedAdmins:
        this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
          this.assignedAdminsUserListWithInactiveUsers,
          formValues.assignedAdmins,
          this.assignmentGroups,
          this.assignedAdminGroupsAndUsersList
        ),
      collaborators:
        this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
          this.collaboratorUserListWithInactiveUsers,
          formValues.collaborators,
          this.assignmentGroups,
          this.collaboratorGroupsAndUsersList
        ),
      assignedQAs:
        this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
          this.assignedQAsUserListWithInactiveUsers,
          formValues.assignedQAs,
          this.assignmentGroups,
          this.assignedQAsGroupsAndUsersList
        ),
      assignedDocControl:
        this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
          this.assignedDocControlUsersListWithInactiveUsers,
          formValues.assignedDocControl,
          this.assignmentGroups,
          this.assignedDocControlGroupsAndUsersList
        ),
      requestedEffectiveDate: (formValues.requestedEffectiveDate!=null || formValues.requestedEffectiveDate!= undefined) ? this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(formValues.requestedEffectiveDate)) : undefined,
      reviewers: formValues.reviewers,
      approvers: formValues.approvers,
      periodicReviewers:  this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
          this.periodicReviewersUserListWithInactiveUsers,
          formValues.periodicReviewers,
          this.assignmentGroups,
          this.periodicReviewersGroupsAndUsersList
        ),
      securityPermissions: formValues.securityPermissions,
      classificationLevel: formValues.classificationLevel,
      eQMSScopes: formValues.eQMSScopes,
      includeQAReview: formValues.includeQAReview,
      convertToPdf: formValues.convertToPdf,
      operationalGroup:
        formValues.operationalGroup === '' ? null : formValues.operationalGroup,
      tags: formValues.tags,
      reasonForDocumentUpdate: this.reasonForDocumentUpdate,
      includesClientSignature:formValues.includesClientSignature!=null ||formValues.includesClientSignature!=undefined? formValues.includesClientSignature: false,
      internalClientContacts:this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(this.internalClientContactsUsersListWithInactiveUsers, formValues.internalClientContacts,this.assignmentGroups, this.internalClientContactsUsersList), 
      mergeClientSignatureAttachment:formValues.mergeClientSignatureAttachment,
      forbidChangesAfterInReviewTransition: formValues.forbidChangesAfterInReviewTransition,
      reason: formValues.reason === '' ? null : formValues.reason,
      documentComments : this.isEditSlider? this.documentDetails.documentComments : null,
      isGlobalDocument : this.isEditSlider? this.documentDetails.isGlobalDocument : false,
      printLock: formValues.printLock,
    };
    this.document = {
      documentVersion: docDetails,
      number: this.isEditSlider ? this.documentNumber : '',
      includeQAReview: formValues.includeQAReview,
      relatedDocuments: [],
      convertToPdf: formValues.convertToPdf,
      isEffectiveDateChanged: this.isEffectiveDateChanged,
      isRequestedEffectiveDateChanged: this.isRequestedEffectiveDateChanged,
      isPeriodicReviewDateChanged: this.isPeriodicReviewDateChanged,
    } ;
  }

  private validateForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.documentForm.invalid) {
      Object.keys(this.documentForm.controls).forEach((key) => {
        if (this.documentForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          errorText && this.errorMessages.push(errorText);
        }
      });
    }
  }

  private checkIfReviewerAndApproverAreSame() {
    if (this.validationErrorEnable)
      this.errorMessages.push(
        DocumentLibraryConstants.Document_ApproverReviewerValidation_ErrorMessage
      );
  }

  private checkIfPeriodicReviewIsNotApplicable() {
    this.isPeriodicReviewerMandatory =
      this.isPeriodicReviewerRequired &&
      (this.documentForm.getRawValue().periodicReviewers == null ||
        (this.documentForm.getRawValue().periodicReviewers != null &&
          this.documentForm.getRawValue().periodicReviewers.length == 0));
    if (this.isPeriodicReviewerMandatory)
      this.errorMessages.push(
        DocumentLibraryConstants.Document_PeriodicReviewer_Rquired
      );
  }

  private checkIfReviewerIsUpdated() {
 // Skip validation if document is being created (no phase yet)
 if (!this.documentDetails?.phase) {
   this.isReviewerListChanged = false;
   return;
 }
  this.isReviewerListChanged = !DocumentLibraryConstants.AllowedReviewerPhases.includes(this.documentDetails?.phase);

    if (this.isReviewerListChanged) {
      var UpdateCheck =
        this.documentDetails.reviewers.length ===
          this.documentForm.getRawValue().reviewers.length &&
        this.documentDetails.reviewers
          .map((reviewer) => reviewer.assignedUserName)
          .every((value: string) =>
            this.documentForm.getRawValue().reviewers.includes(value)
          );
      this.isReviewerListChanged = !UpdateCheck;
    }
    if (this.isReviewerListChanged)
      this.errorMessages.push(
        DocumentLibraryConstants.Document_ReviewerChangeAfterFormatting_ErrorMessage
      );
  }

 private checkIfApproverIsUpdated() {

   // Skip validation if document is being created (no phase yet)
 if (!this.documentDetails?.phase) {
   this.isApproverListChanged = false;
   return;
 }
  this.isApproverListChanged = !DocumentLibraryConstants.AllowedApproverPhases.includes(this.documentDetails?.phase);

  if (this.isApproverListChanged) {
    
      var UpdateCheck =
        this.documentDetails.approvers.length ===
          this.documentForm.getRawValue().approvers.length &&
        this.documentDetails.approvers
          .map((approver) => approver.assignedUserName)
          .every((value: string) =>
            this.documentForm.getRawValue().approvers.includes(value)
          );
      this.isApproverListChanged = !UpdateCheck;
    }
  
  if (this.isApproverListChanged)
    this.errorMessages.push(
      DocumentLibraryConstants.Document_ApproverChangeAfterReviewPhase_ErrorMessage
    );
}

  closeAndResetDocumentSlider() {
    if (!this.isEditSlider) {
      this.documentForm.reset();
      this.setDefaultsForDocumentForm();
      this.isInitialeQMSScopeSelection = false;
    } else {
      this.documentPersistenceService.linkedDocuments =
        this.documentDetailsForEdit.relatedDocuments;
    }
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    this.isRequestedEffectiveDateChanged = false;
    this.isEffectiveDateChanged = false;
    this.isPeriodicReviewDateChanged = false;
    this.documentForm.controls['securityPermissions'].setValue([22]);
    this.documentForm.controls['confidentialityLevel'].setValue(1);
  }

  private setDefaultsForDocumentForm() {
    if (!!this.documentForm) {
      this.documentForm.patchValue({
        effectiveDate: null,
        periodicReviewDate: null,
        includeQAReview: true,
        convertToPdf: true,
        mergeClientSignatureAttachment: false,
        forbidChangesAfterInReviewTransition: false,
        printLock: false,
      });
      this.documentForm.controls['operationalGroup'].setValue(null);
      this.documentForm.controls['category'].setValue(null);
      this.disableControls('category');
      this.disableControls('internalClientContacts');
      this.disableControls('operationalGroup');
      this.disableControls('forbidChangesAfterInReviewTransition');
      this.disableControls('printLock');
      if (
        this.documentForm.controls['convertToPdf'].getRawValue() &&
        this.documentForm.controls['includesClientSignature'].getRawValue()
      ) {
        this.enableControls('mergeClientSignatureAttachment');
        this.documentForm.patchValue({
          mergeClientSignatureAttachment: false,
        });
      } else {
        this.disableControls('mergeClientSignatureAttachment');
      }
    }
  }
  private getErrorMessageText(labelName: string) {
    let errorText: string = '';
    switch (labelName) {
      case 'title':
        errorText = DocumentLibraryConstants.Document_Title_Required;
        this.mandatoryFields.title = true;
        break;
      case 'phase':
        errorText = DocumentLibraryConstants.Document_Phase_Required;
        this.mandatoryFields.phase = true;
        break;
      case 'division':
        errorText = DocumentLibraryConstants.Document_Division_Required;
        this.mandatoryFields.division = true;
        break;
      case 'functionalArea':
        errorText = DocumentLibraryConstants.Document_FunctionalArea_Required;
        this.mandatoryFields.functionalArea = true;
        break;
      case 'documentType':
        errorText = DocumentLibraryConstants.Document_DocumentType_Required;
        this.mandatoryFields.documentType = true;
        break;
      case 'assignedDocControl':
        errorText =
          DocumentLibraryConstants.Document_assignedDocControl_Required;
        this.mandatoryFields.assignedDocControl = true;
        break;
      case 'confidentialityLevel':
        errorText =
          DocumentLibraryConstants.Document_confidentialityLevel_Required;
        this.mandatoryFields.confidentialityLevel = true;
        break;
      case 'reviewers':
        errorText = DocumentLibraryConstants.Document_Reviewers_Required;
        this.mandatoryFields.reviewers = true;
        break;
      case 'approvers':
        errorText = DocumentLibraryConstants.Document_Approvers_Required;
        this.mandatoryFields.approvers = true;
        break;
      case 'version':
        errorText = DocumentLibraryConstants.Document_Version_Required;
        this.mandatoryFields.version = true;
        break;
      case 'periodicReviewCycle':
        errorText =
          DocumentLibraryConstants.Document_PeriodicReviewCycle_Required;
        this.mandatoryFields.periodicReviewCycle = true;
        break;
      case 'author':
        errorText = DocumentLibraryConstants.Document_Author_Required;
        this.mandatoryFields.author = true;
        break;
      case 'eQMSScopes':
        errorText = DocumentLibraryConstants.Document_location_Required;
        this.mandatoryFields.eQMSScopes = true;
        break;
      case 'assignedAdmins':
        errorText = DocumentLibraryConstants.Document_Admin_Required;
        this.mandatoryFields.assignedAdmins = true;
        break;
      case 'securityPermissions':
        errorText =
          DocumentLibraryConstants.Document_securityPermission_Required;
        this.mandatoryFields.securityPermissions = true;
        break;
    }
    return errorText;
  }

  // To capture the changes for input controls
  private onFormControlChanges() {
    this.documentForm
      ?.get('periodicReviewCycle')
      ?.valueChanges.subscribe((periodicReviewCycleValue) => {
        this.isPeriodicReviewCycleIsNA =
          periodicReviewCycleValue ===
          DocumentLibraryConstants.PeriodicReviewCycle_NotApplicable_OptionValue;
        if (
          periodicReviewCycleValue ===
          DocumentLibraryConstants.PeriodicReviewCycle_NotApplicable_OptionValue
        ) {
          this.isPeriodicReviewCycleIsNA = true;
          this.documentForm.patchValue({
            periodicReviewDate: null,
          });
        } else {
          this.isPeriodicReviewCycleIsNA = false;
        }
      });
    this.documentForm
      ?.get('includeQAReview')
      ?.valueChanges.subscribe((includeQAReviewValue) => {
        this.isAssignedQAControlEnabled = includeQAReviewValue;
        this.documentForm.patchValue({
          assignedQAs: !includeQAReviewValue
            ? null
            : this.documentDetailsForEdit?.assignedQAs.map(
                (obj) => obj.assignedUserName
              ),
        });
      });

    this.documentForm
      ?.get('effectiveDate')
      ?.valueChanges.subscribe((newValue) => {
        this.isEffectiveDateChanged = this.hasDateChanged(
          newValue,
          this.documentDetailsForEdit?.effectiveDate
        );
      });

    this.documentForm
      ?.get('periodicReviewDate')
      ?.valueChanges.subscribe((newValue) => {
        this.isPeriodicReviewDateChanged = this.hasDateChanged(
          newValue,
          this.documentDetailsForEdit?.periodicReviewDate
        );
      });

    this.documentForm
      ?.get('requestedEffectiveDate')
      ?.valueChanges.subscribe((newValue) => {
        this.isRequestedEffectiveDateChanged = this.hasDateChanged(
          newValue,
          this.documentDetailsForEdit?.requestedEffectiveDate
        );
      });

    this.documentForm
      ?.get('includesClientSignature')
      ?.valueChanges.subscribe((includeClientSignatureValue) => {
        this.isInternalClientContactControlEnabled =
          includeClientSignatureValue;
        this.documentForm.patchValue({
          internalClientContacts: !includeClientSignatureValue
            ? null
            : this.documentDetailsForEdit?.internalClientContacts.map(
                (obj) => obj.assignedUserName
              ),
        });
      });
  }
  /** Compares two nullable date values not by date & time; returns true if they differ. */
  private hasDateChanged(newValue: any, originalValue: any): boolean {
    if (newValue == null && (originalValue == null || originalValue === undefined)) {
      return false;
    }
    if (newValue != null && originalValue != null) {
      return new Date(newValue).toDateString() !== new Date(originalValue).toDateString();
    }
    return true;
  }

  //To get Name as Name With Code
  private getListWithNameCodeAsName(dataList: any) {
    let listWithNameAndCodeValues: any = [];
    for (var dataItem of dataList) {
      listWithNameAndCodeValues.push({
        value: dataItem.code,
        name: `${dataItem.code} - ${dataItem.name}`,
      });
    }
    return listWithNameAndCodeValues;
  }

  private getDefaultMandatoryFieldsObject() {
    return {
      title: false,
      periodicReviewCycle: false,
      phase: false,
      division: false,
      functionalArea: false,
      documentType: false,
      eQMSScopes: false,
      author: false,
      assignedDocControl: false,
      reviewers: false,
      approvers: false,
      version: false,
      assignedAdmins: false,
      securityPermissions: false,
      confidentialityLevel: false,
    };
  }

  private checkSliderFromDocumentDetails() {
    if (this.router.url.includes('eqms.documentDetails/')) {
      this.isEditSlider = true;
      this.disableControls(['division', 'functionalArea', 'documentType']);
    }
  }

  private loadDocumentSliderWithDetails() {
    var url = this.router.url;
    if (url.includes('eqms.documentDetails/')) {
      var docParts = url.substring(url.lastIndexOf('/') + 1, url.length);
      if (docParts != null || docParts != undefined) {
        if (docParts.includes(':')) {
          this.documentNumber = docParts.substring(0, docParts.indexOf(':'));
          var docVersion = docParts.substring(
            docParts.indexOf(':') + 1,
            docParts.length
          );
          if (docVersion == 'latest') this.isLatestDocument = true;
          else
            this.version = Number(
              docParts.substring(docParts.indexOf(':') + 1, docParts.length)
            );
          this.isEffective = false;
        } else {
          this.documentNumber = docParts;
          this.isEffective = true;
        }
        this.loadDocumentDetails();
      }
    }
  }

  private loadDocumentDetails() {
    // Unsubscribe from any previous API call subscription
    if (this.loadDocumentDetailsSubscription) {
      this.loadDocumentDetailsSubscription.unsubscribe();
    }
    
    const handleDocumentData = (documentData: any) => {
      this.documentDetails = documentData;
      this.documentPersistenceService.clientSignatureAttachmentVisibile =
        this.documentDetails.isClientSignatureAttachmentAvailable!;
      
      // Unsubscribe from previous subscription if it exists
      if (this.documentDetailsSubscription) {
        this.documentDetailsSubscription.unsubscribe();
      }
      
      const isMetadataReady = this.isDocumentMetadataReady();
      
      if (isMetadataReady) {
        setTimeout(() => {
          this.populateDocumentDetailsForEdit();
        }, 0);
      } else {
        // Wait for documentBindData to be ready, then populate
        this.documentDetailsSubscription = this.documentsservice.editDocumentMetaDataLoaded$
          .pipe(
            filter((loaded: boolean) => loaded && this.isDocumentMetadataReady()),
            take(1)
          )
          .subscribe(() => {
            setTimeout(() => {
              this.populateDocumentDetailsForEdit();
            }, 0);
          });
      }
      
      this.isEffectiveVersionHide =
        this.isEditSlider &&
        this.excludedPhasesForHide.indexOf(this.documentDetails.phase) === -1;
      this.isEffectiveVersionLabelDisabled =
        this.isEditSlider &&
        !this.isEffectiveVersionHide &&
        (this.documentDetails.phase === 5 || this.documentDetails.phase === 6);
      this.isEffectiveVersionLabelDisabled
        ? this.disableControls('effectiveDate')
        : this.enableControls('effectiveDate');
    };

    if (this.isLatestDocument === true) {
      this.loadDocumentDetailsSubscription = this.documentsservice
        .getLatestDocumentDetail(this.documentNumber)
        .subscribe(handleDocumentData);
    } else if (this.version !== undefined && this.version !== null && this.version >= 0) {
      this.loadDocumentDetailsSubscription = this.documentsservice
        .getDocumentDetailByVersion(this.documentNumber, this.version)
        .subscribe(handleDocumentData);
    } else {
      this.loadDocumentDetailsSubscription = this.documentsservice
        .getDocumentDetail(this.documentNumber, this.isEffective)
        .subscribe(handleDocumentData);
    }
  }

  private constructEditDocumentDetails() {
    this.documentDetailsForEdit = JSON.parse(
      JSON.stringify(this.documentDetails)
    );
    this.documentDetailsForEdit.classificationLevel = this.populateIdForValue(
      'classificationLevel',
      this.documentDetails?.classificationLevel
    );
    this.documentDetailsForEdit.confidentialityLevel = this.populateIdForValue(
      'confidentialityLevel',
      this.documentDetails?.confidentialityLevel
    );
    this.documentDetailsForEdit.localType = this.populateIdForValue(
      'localType',
      this.documentDetails?.localType
    );
    this.documentDetailsForEdit.localLevel = this.populateIdForValue(
      'localLevel',
      this.documentDetails?.localLevel
    );
    this.documentDetailsForEdit.periodicReviewCycle = this.populateIdForValue(
      'periodicReviewCycle',
      this.documentDetails?.periodicReviewCycle
    );
    this.documentDetailsForEdit.category = this.documentDetailsForEdit.category;
    this.documentPersistenceService.linkedDocuments =
      this.documentDetailsForEdit.relatedDocuments;

    this.documentDetailsForEdit.operationalGroup = this.populateIdForValue(
      'operationalGroup',
      this.documentDetails?.operationalGroup
    );
  }

  private validate(value: any) {
    return value !== null && value !== '' && value !== undefined;
  }


// Update the populateDocumentDetailsForEdit method
private populateDocumentDetailsForEdit() {
  // Ensure eQMSScopeList is loaded
  if (!this.eQMSScopeList || this.eQMSScopeList.length === 0) {
    console.warn('eQMSScopeList not loaded yet, loading...');
    return;
  }

  this.constructEditDocumentDetails();
  
  this.isAssignedQAControlEnabled =
    this.documentDetailsForEdit?.includeQAReview ?? false;
  this.isInternalClientContactControlEnabled =
    this.documentDetailsForEdit?.includesClientSignature ?? false;
  this.ValidateAndDisplayRequestedEffectiveDate();
  
  // Apply enable/disable rules based on phase and classification
  this.documentDetailsForEdit.phase == 0
    ? this.enableControls('includeQAReview')
    : this.disableControls('includeQAReview');
  this.documentDetailsForEdit.phase === 0 ||
  this.documentDetailsForEdit.phase === 1 ||
  this.documentDetailsForEdit.phase === 2
    ? this.enableControls('includesClientSignature')
    : this.disableControls('includesClientSignature');
  this.documentDetailsForEdit.phase == 0
    ? this.enableControls('convertToPdf')
    : this.disableControls('convertToPdf');
  this.documentDetailsForEdit.phase < 3 ||
  this.documentDetailsForEdit.phase === 10
    ? this.enableControls('mergeClientSignatureAttachment')
    : this.disableControls('mergeClientSignatureAttachment');
  this.documentDetailsForEdit.phase == 5 ||
  this.documentDetailsForEdit.phase == 6
    ? this.disableControls('title')
    : this.enableControls('title');
  this.phasesToDisableForbidChangesAfterInReviewTransition.indexOf(
    this.documentDetailsForEdit.phase
  ) !== -1
    ? this.disableControls('forbidChangesAfterInReviewTransition')
    : this.enableControls('forbidChangesAfterInReviewTransition');

  (this.documentDetailsForEdit.phase === 0 || this.documentDetailsForEdit.phase === 1 || this.documentDetailsForEdit.phase === 2) 
    ? this.enableControls('reason') : this.disableControls('reason');
    
  if (this.documentDetailsForEdit.classificationLevel == '0') {
    this.enableControls('category');
    this.disableControls('operationalGroup');
  } else if (this.documentDetailsForEdit.classificationLevel == '1') {
    this.enableControls('operationalGroup');
    this.disableControls('category');
  }
  this.disableControls('printLock');
  
  // Force change detection before patching
  this.changeDetectorRef.detectChanges();
  
  // Use setTimeout to ensure the view is updated
  setTimeout(() => {
    this.patchFormValues();
    this.rebindEditScopeSelection();
    this.changeDetectorRef.detectChanges();
  }, 0);
}


  private patchFormValues(): void {
    const eQMSScopeValues = this.getNormalizedScopeValues(
      this.documentDetailsForEdit?.eQMSScopes
    );

    const formValues = {
      title: this.documentDetailsForEdit.title,
      phase: this.documentDetailsForEdit.phase,
      version: this.documentDetailsForEdit?.version,
      legacyDocument: this.validate(
        this.documentDetailsForEdit?.legacyDocumentNumber
      )
        ? this.documentDetailsForEdit?.legacyDocumentNumber
         : null,
      confidentialityLevel: this.validate(
        this.documentDetailsForEdit.confidentialityLevel
      )
        ? this.documentDetailsForEdit.confidentialityLevel
         : null,
      effectiveDate: this.validate(this.documentDetailsForEdit?.effectiveDate)
        ? new Date(this.documentDetailsForEdit?.effectiveDate as Date)
         : null,
      periodicReviewCycle: this.documentDetailsForEdit.periodicReviewCycle,
      periodicReviewDate: this.validate(
        this.documentDetailsForEdit?.periodicReviewDate
      )
        ? new Date(this.documentDetailsForEdit?.periodicReviewDate as Date)
         : null,
      category: this.validate(this.documentDetailsForEdit?.category)
        ? this.documentDetailsForEdit?.category?.split(' -')[0]
         : null,
      division: 
      this.documentDetailsForEdit?.division !== null
        ? this.documentDetailsForEdit?.division?.split(' -')[0]
         : null,
      functionalArea: 
      this.documentDetailsForEdit?.functionalArea !== null
        ? this.documentDetailsForEdit?.functionalArea?.split(' -')[0]
         : null,
      documentType:
       this.documentDetailsForEdit?.documentType !== null
        ? this.documentDetailsForEdit?.documentType?.split(' -')[0]
         : null,
      localLevel: this.validate(this.documentDetailsForEdit.localLevel)
        ? this.documentDetailsForEdit?.localLevel
         : null,
      localCategory:
       this.documentDetailsForEdit?.localCategory?.split(' -')[0],
      localType: this.validate(this.documentDetailsForEdit?.localType)
        ? this.documentDetailsForEdit?.localType
         : null,
      responsibleSubBusinessUnit: this.validate(
        this.documentDetailsForEdit?.responsibleSubBusinessUnit
      )
        ? this.documentDetailsForEdit?.responsibleSubBusinessUnit
         : null,
      author:
       this.documentDetailsForEdit?.author !== null
        ? this.documentDetailsForEdit?.author.assignedUserName
         : null,
        assignedAdmins: this.documentDetailsForEdit.assignedAdmins?.map(
          (obj) => obj.assignedUserName
        ),
        collaborators: this.documentDetailsForEdit.collaborators?.map(
          (obj) => obj.assignedUserName
        ),
        assignedQAs: this.documentDetailsForEdit?.includeQAReview
          ? this.documentDetailsForEdit.assignedQAs.map(
              (obj) => obj.assignedUserName
            )
          : null,
        assignedDocControl: this.documentDetailsForEdit.assignedDocControl?.map(
          (obj) => obj.assignedUserName
        ),
        requestedEffectiveDate:
          this.documentDetailsForEdit.requestedEffectiveDate != null
            ? new Date(
                this.documentDetailsForEdit.requestedEffectiveDate as Date
              )
      : null,
        reviewers:
          this.documentDetailsForEdit?.reviewers !== null
            ? this.documentDetailsForEdit?.reviewers?.map(
                (obj) => obj.assignedUserName
              )
            : null,
        approvers:
          this.documentDetailsForEdit?.approvers !== null
            ? this.documentDetailsForEdit?.approvers?.map(
                (obj) => obj.assignedUserName
              )
            : null,
        periodicReviewers: this.documentDetailsForEdit?.periodicReviewers?.map(
          (obj) => obj.assignedUserName
        ),
        securityPermissions:
          this.documentDetailsForEdit?.securityPermissions !== null
            ? this.populateValueForDropDown(
                'securityPermissions',
                this.documentDetailsForEdit?.securityPermissions
              )
            : null,
        classificationLevel:
          this.documentDetailsForEdit.classificationLevel != null &&
          this.documentDetailsForEdit.classificationLevel !== ''
            ? this.documentDetailsForEdit.classificationLevel
            : null,
        eQMSScopes: eQMSScopeValues,
        includeQAReview: this.documentDetailsForEdit?.includeQAReview,
        convertToPdf: this.documentDetailsForEdit?.convertToPdf,
        operationalGroup:
          this.documentDetailsForEdit?.operationalGroup != null &&
          this.documentDetailsForEdit?.operationalGroup !== ''
            ? this.documentDetailsForEdit?.operationalGroup
            : null,
        tags:
          this.documentDetailsForEdit?.tags !== null
            ? this.populateValueForDropDown(
                'tags',
                this.documentDetailsForEdit?.tags
              )
            : null,
      includesClientSignature:
       this.documentDetailsForEdit?.includesClientSignature,
      internalClientContacts: this.documentDetailsForEdit
      ?.internalClientContacts
        ? this.documentDetailsForEdit.internalClientContacts.map(
          (obj) => obj.assignedUserName
        )
           : null,
      mergeClientSignatureAttachment:this.documentDetailsForEdit?.mergeClientSignatureAttachment ?? false,
      forbidChangesAfterInReviewTransition: this.documentDetailsForEdit?.forbidChangesAfterInReviewTransition ?? false,
      reason: this.validate(this.documentDetailsForEdit?.reason) ? this.documentDetailsForEdit?.reason : null,
      printLock: this.documentDetailsForEdit?.printLock ?? false,
    };
    this.documentForm.reset(formValues, { emitEvent: false });
    this.validateeQMSScopes();
    this.changeDetectorRef.detectChanges();

    if (eQMSScopeValues && eQMSScopeValues.length > 0) {
      setTimeout(() => {
        this.documentForm.controls['eQMSScopes'].setValue(eQMSScopeValues, {
          emitEvent: false,
        });
        this.validateeQMSScopes();
        this.changeDetectorRef.detectChanges();
      }, 0);
    }

    this.checkandAddInActiveAssignmentGroupstoUserList();
    this.enableOtherTabs.emit(true);
  }

  private rebindEditScopeSelection(): void {
    if (!this.isEditSlider || !this.documentDetailsForEdit) {
      return;
    }

    const eQMSScopeValues = this.getNormalizedScopeValues(
      this.documentDetailsForEdit?.eQMSScopes
    );

    if (!eQMSScopeValues || eQMSScopeValues.length === 0) {
      return;
    }

    this.documentForm.controls['eQMSScopes'].setValue(eQMSScopeValues, {
      emitEvent: false,
    });
    this.validateeQMSScopes();
  }

  private getNormalizedScopeValues(scopes?: number[] | string[] | null): number[] | null {
    if (!scopes || scopes.length === 0) {
      return null;
    }

    const normalizedScopes = scopes
      .map((scopeId: number | string) => Number(scopeId))
      .filter((scopeId: number) => !isNaN(scopeId));

    return normalizedScopes.length > 0 ? normalizedScopes : null;
  }

  checkandAddInActiveAssignmentGroupstoUserList() {
    this.inactiveAssignments = [];
    [
      'assignedAdmins',
      'collaborators',
      'assignedQAs',
      'assignedDocControl',
      'periodicReviewers'
    ].forEach((property) => {
      const assignments =
        this.documentDetailsForEdit[property as keyof DocumentDetail];

      if (Array.isArray(assignments)) {
        const hasInactive = assignments.some(
          (assignment) => !assignment.isActive
        );

        if (hasInactive) {
          this.inactiveAssignments.push({ property, assignments });
        }
      } else if (assignments && !assignments.isActive) {
        this.inactiveAssignments.push({ property, assignments });
      }
    });
  }

  private populateValueForDropDown(
    fieldType: string,
    fieldName?: string[]
  ): any[] {
    if (fieldName == null) return [];

    let fieldValues: string[] = [];
    switch (fieldType) {
      case 'tags':
        fieldName.forEach((fieldValue: any) => {
          fieldValues.push(
            this.documentBindData.tags?.find((cl: any) => cl.name == fieldValue)
              .value
          );
        });
        break;
      case 'securityPermissions':
        fieldName.forEach((fieldValue: any) => {
          fieldValues.push(
            this.documentBindData.securities?.find(
              (cl: any) => cl.name == fieldValue
            ).value
          );
        });
        break;
    }
    return fieldValues;
  }

  private populateIdForValue(fieldType: string, fieldValue?: string) {
    let fieldId = '';
    if (fieldValue == null) return fieldId;

    switch (fieldType) {
      case 'classificationLevel':
        fieldId = this.documentBindData.classificationLevel?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
      case 'confidentialityLevel':
        fieldId = this.documentBindData.confidentialityLevels?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
      case 'localLevel':
        fieldId = this.documentBindData.localLevels?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
      case 'localType':
        fieldId = this.documentBindData.localTypes?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
      case 'securityPermissions':
        fieldId = this.documentBindData.securities?.find(
          (cl: any) => cl.name == fieldValue
        ).value;
        break;
      case 'periodicReviewCycle':
        if (!!fieldValue) {
          fieldId = this.documentBindData.periodicReviewCycles?.find(
            (cl: any) => cl.name == fieldValue
          ).value;
        }
        break;
      case 'operationalGroup':
        if (!!fieldValue) {
          fieldId = this.documentBindData.operationalGroup?.find(
            (cl: any) => cl.name == fieldValue
          ).value;
        }
        break;
    }
    return fieldId;
  }

  private getLoggedInUser = (): string => {
    let loggedInUserFullName: string = '';
    let puid: string = sessionStorage.getItem('puid') || '';
    if (this.userList.length > 0 && puid.length > 0) {
      loggedInUserFullName = this.userList.find((user: NameValue) =>
        user.name.includes(`(${puid})`)
      )?.name;
    }
    return loggedInUserFullName;
  };

  selectedValue(event: any) {
    if (event.value === 0) {
      this.enableControls('category');
      this.disableControls('operationalGroup');

      this.documentForm.controls['operationalGroup'].setValue(null);
    } else if (event.value === 1) {
      this.disableControls('category');
      this.enableControls('operationalGroup');

      this.documentForm.controls['category'].setValue(null);
    } else if (event.value == null) {
      this.disableControls('category');
      this.disableControls('operationalGroup');

      this.documentForm.controls['operationalGroup'].setValue(null);
      this.documentForm.controls['category'].setValue(null);
    }
    this.changeDetectorRef.detectChanges();
  }

  validateeQMSScopes() {
    if (
      this.documentForm.getRawValue().eQMSScopes == null ||
      this.documentForm.getRawValue().eQMSScopes.length == 0
    ) {
      this.iseQMSScopeSelected = false;
      if (!this.isEditSlider) { 
        this.isInitialeQMSScopeSelection = false;
        this.documentForm.controls[
          'forbidChangesAfterInReviewTransition'
        ].setValue(false);
        this.documentForm.controls[
          'printLock'
        ].setValue(false);
      }
      this.disableControls([
        'author',
        'assignedAdmins',
        'collaborators',
        'assignedDocControl',
        'reviewers',
        'approvers',
        'periodicReviewers',
        'forbidChangesAfterInReviewTransition',
        'printLock'
      ]);
      this.initializeLists();
    } else {
      this.iseQMSScopeSelected = true;
      this.enableControls([
        'author',
        'assignedAdmins',
        'collaborators',
        'assignedDocControl',
        'reviewers',
        'approvers',
        'periodicReviewers',
      ]);
      if (!this.isEditSlider) {
        this.enableControls('forbidChangesAfterInReviewTransition');
        this.enableControls('printLock');
        if (!this.isInitialeQMSScopeSelection) {
          this.isInitialeQMSScopeSelection = true;
          this.SetForbidChangesforInReviewDocument();
          this.SetPrintLockDocument();
        }
      } else if (this.isEditSlider) {
        this.enableControls('printLock');
        this.phasesToDisableForbidChangesAfterInReviewTransition.indexOf(
          this.documentDetailsForEdit.phase
        ) !== -1
          ? this.disableControls('forbidChangesAfterInReviewTransition')
          : this.enableControls('forbidChangesAfterInReviewTransition');
      }
      if (this.assignmentGroupsSubscription) {
        this.assignmentGroupsSubscription.unsubscribe();
      }
      this.debounceSubject.next();
    }
    if (
      this.documentForm.controls['includesClientSignature'].value === true &&
      this.iseQMSScopeSelected === true
    ) {
      this.enableControls(['internalClientContacts']);
    } else {
      this.disableControls(['internalClientContacts']);
    }
  }

  async loadUserList() {
    // To load users data
    this.usersService
      .getUsersForDocument(this.documentForm.getRawValue().eQMSScopes)
      .subscribe(async (usersData) => {
        this.userList = [];
        for (let dataItem of usersData) {
          this.userList.push({
            value: dataItem.name,
            name: dataItem.name,
          });

          // Check if the 'author' control has a value which mean its an Edit document check
          let authorControl = this.documentForm.controls['author'];
          if (!authorControl.value) {
            let loggedInUser = this.getLoggedInUser();
            authorControl.setValue(loggedInUser);
          }
        }
        //Below method is used to add the userList data to assigmentUsersList
        await this.initializeLists();
        //To get assignment groups based on scopes
        this.getAssignementGroupsForEachScope();
      });
  }

  getAssignementGroupsForEachScope() {
    const eQMSScopes = this.documentForm.getRawValue().eQMSScopes;
    if (!eQMSScopes) {
      return;
    }
    const request = new AssignmentGroupsRequest(
      eQMSScopes,
      this.documentAssignmentTypes
    );

    this.assignmentGroupsSubscription = this.documentsservice
      .getAssignmentGroups(request)
      .subscribe((assignmentGroups: any) => {
        this.assignmentGroups = assignmentGroups;
        //this.initializeLists();
        for (let ag of assignmentGroups) {
          const userExists = this.documentPersistenceService.usersList.some((user : any) => user.id === ag.id || user.name === ag.name);
          if (!userExists) {
            this.documentPersistenceService.usersList.unshift({
              value: ag.name,
              name: ag.name,
              id: ag.id,
            });
          }          
          switch (ag.assignment) {
            case DocumentLibraryConstants.Assignment_types.Collaborator:
              this.collaboratorGroupsAndUsersList.unshift({
                value: ag.name,
                name: ag.name,
                id: ag.id,
              });
              break;
            case DocumentLibraryConstants.Assignment_types.AssignedDocControl:
              this.assignedDocControlGroupsAndUsersList.unshift({
                value: ag.name,
                name: ag.name,
                id: ag.id,
              });
              break;
            case DocumentLibraryConstants.Assignment_types.AssignedAdmins:
              this.assignedAdminGroupsAndUsersList.unshift({
                value: ag.name,
                name: ag.name,
                id: ag.id,
              });
              break;
            case DocumentLibraryConstants.Assignment_types.AssignedQA:
              this.assignedQAsGroupsAndUsersList.unshift({
                value: ag.name,
                name: ag.name,
                id: ag.id,
              });
              break;
            case DocumentLibraryConstants.Assignment_types.PeriodicReviewer:
              this.periodicReviewersGroupsAndUsersList.unshift({
                value: ag.name,
                name: ag.name,
                id: ag.id,
              });
              break;
          }
        }
        if (this.inactiveAssignments && this.inactiveAssignments.length > 0) {
          this.getInactiveAssignmentGroups();
        }
        //this.sortAssignmentGroupList();
        this.reassignDocumentFormWithAssignmentValues();
      });
  }
  getInactiveAssignmentGroups() {
    for (let ag of this.inactiveAssignments) {
      let prop = ag.property;
      let assignments = ag.assignments;
      let filteredAssignments = [];
      if (Array.isArray(assignments)) {
        filteredAssignments = assignments.filter(
          (assignment: any) => assignment.assignmentType === 0
        );
      } else if (assignments && assignments.assignmentType === 0) {
        filteredAssignments = [assignments];
      }

      let inActiveAssignmentGroupData = filteredAssignments.map(
        (assignment: any) => ({
          value: assignment.assignedUserName,
          name: assignment.assignedUserName,
          id: assignment.assignmentId,
          isActive: assignment.isActive,
        })
      );

      // To which list we need to add objects based on the property value
      if (prop.includes('assignedAdmins')) {
        this.assignedAdminGroupsAndUsersList.push(
          ...inActiveAssignmentGroupData
        );
      } else if (prop.includes('assignedQAs')) {
        this.assignedQAsGroupsAndUsersList.push(...inActiveAssignmentGroupData);
      } else if (prop.includes('assignedDocControl')) {
        this.assignedDocControlGroupsAndUsersList.push(
          ...inActiveAssignmentGroupData
        );
      } else if (prop.includes('periodicReviewers')) {
        this.periodicReviewersGroupsAndUsersList.push(
          ...inActiveAssignmentGroupData
        );
      } else {
        this.collaboratorGroupsAndUsersList.push(
          ...inActiveAssignmentGroupData
        );
      }
    }
  }

  private async initializeLists(): Promise<void> {
    // If it is for create document slider, load the default users lists based on logic
    if (!this.isEditSlider) {
      //initialize all the lists
      this.collaboratorGroupsAndUsersList = [];
      this.assignedAdminGroupsAndUsersList = [];
      this.assignedQAsGroupsAndUsersList = [];
      this.assignedDocControlGroupsAndUsersList = [];
      this.reviewersList = [];
      this.approversList = [];
      this.periodicReviewersGroupsAndUsersList = [];
      this.authorList = [];

      //Assigned usersList for all the dropdowns and temporary lists
      this.collaboratorUserListWithInactiveUsers = [...this.userList];
      this.assignedAdminsUserListWithInactiveUsers = [...this.userList];
      this.assignedQAsUserListWithInactiveUsers = [...this.userList];
      this.assignedDocControlUsersListWithInactiveUsers = [...this.userList];
      this.internalClientContactsUsersListWithInactiveUsers = [
        ...this.userList,
      ];
      this.periodicReviewersUserListWithInactiveUsers = [...this.userList];
      this.internalClientContactsUsersList = [...this.userList]; //While creating a new document, the user is assigned for internal client
      this.collaboratorGroupsAndUsersList = [...this.userList];
      this.assignedAdminGroupsAndUsersList = [...this.userList];
      this.assignedQAsGroupsAndUsersList = [...this.userList];
      this.assignedDocControlGroupsAndUsersList = [...this.userList];
      this.reviewersList = [...this.userList];
      this.approversList = [...this.userList];
      this.periodicReviewersGroupsAndUsersList = [...this.userList];
      this.authorList = [...this.userList];
    }

    //If it is edit slider, process the users list drop downs for inactive users presence
    else {
      this.usersListToValidate = [];
      this.collaboratorUserListWithInactiveUsers = [...this.userList];
      this.assignedAdminsUserListWithInactiveUsers = [...this.userList];
      this.assignedQAsUserListWithInactiveUsers = [...this.userList];
      this.assignedDocControlUsersListWithInactiveUsers = [...this.userList];
      this.internalClientContactsUsersListWithInactiveUsers = [
        ...this.userList,
      ]; //While editing document, user including InactiveUsers user is assigned here
      this.reviewersWithInactiveUsers = [...this.userList];
      this.approversWithInactiveUsers = [...this.userList];
      this.periodicReviewersUserListWithInactiveUsers = [...this.userList];
      this.authorWithInactiveUsers = [...this.userList];

      this.usersListToValidate.push({
        userType: UserType.Collaborators,
        userAssignmentList: this.documentDetailsForEdit.collaborators,
      });
      this.usersListToValidate.push({
        userType: UserType.AssignedAdmins,
        userAssignmentList: this.documentDetailsForEdit.assignedAdmins,
      });
      this.usersListToValidate.push({
        userType: UserType.AssignedQAs,
        userAssignmentList: this.documentDetailsForEdit.assignedQAs,
      });
      this.usersListToValidate.push({
        userType: UserType.AssignedDocControls,
        userAssignmentList: this.documentDetailsForEdit.assignedDocControl,
      });
      this.usersListToValidate.push({
        userType: UserType.Reviewers,
        userAssignmentList: this.documentDetailsForEdit.reviewers,
      });
      this.usersListToValidate.push({
        userType: UserType.Approvers,
        userAssignmentList: this.documentDetailsForEdit.approvers,
      });
      this.usersListToValidate.push({
        userType: UserType.PeriodicReviewers,
        userAssignmentList: this.documentDetailsForEdit.periodicReviewers,
      });
      this.usersListToValidate.push({
        userType: UserType.DocumentInternalClientContacts,
        userAssignmentList: this.documentDetailsForEdit.internalClientContacts,
      });

      let authorInfo: AssignmentDTO[] = [];
      authorInfo.push(this.documentDetailsForEdit.author);
      this.usersListToValidate.push({
        userType: UserType.Author,
        userAssignmentList: authorInfo,
      });

      // Fetch and process the validated users list
      this.validatedUsersList = await firstValueFrom(
        this.usersService.validateUsers(this.usersListToValidate)
      );
      this.documentPersistenceService.validatedUsersList =
        this.validatedUsersList;

      let userListToValidate = this.userList;

      // Extract non-terminated users and map them to the desired structure
      const nonTerminatedUserList = this.validatedUsersList
        .flatMap((user: any) => user.userAssignmentList || [])
        .filter((user: any) => user.assignmentType == 0 && !user.isTerminated)
        .map((user: any) => ({
          value: user.value,
          name: user.assignedUserName
        }));
      userListToValidate = userListToValidate.concat(nonTerminatedUserList);
      this.documentPersistenceService.usersList = userListToValidate;
      if (this.validatedUsersList.length > 0) {
        // Iterate through each userInfo in the validatedUsersList
        this.validatedUsersList.forEach((userInfo) => {
          // Filter only inactive user types for binding dropdown lists
          const filteredAssignments = userInfo.userAssignmentList.filter(
            (assignment) => assignment.assignmentType != 0
          );

          // Determine the target list based on user type
          let targetList: { name: string; value: string }[] = [];

          switch (userInfo.userType) {
            case UserType.Collaborators:
              targetList = this.collaboratorUserListWithInactiveUsers;
              break;
            case UserType.AssignedAdmins:
              targetList = this.assignedAdminsUserListWithInactiveUsers;
              break;
            case UserType.AssignedQAs:
              targetList = this.assignedQAsUserListWithInactiveUsers;
              break;
            case UserType.AssignedDocControls:
              targetList = this.assignedDocControlUsersListWithInactiveUsers;
              break;
            case UserType.Reviewers:
              targetList = this.reviewersWithInactiveUsers;
              break;
            case UserType.Approvers:
              targetList = this.approversWithInactiveUsers;
              break;
            case UserType.PeriodicReviewers:
              targetList = this.periodicReviewersUserListWithInactiveUsers;
              break;
            case UserType.Author:
              targetList = this.authorWithInactiveUsers;
              break;
            case UserType.DocumentInternalClientContacts:
              targetList =
                this.internalClientContactsUsersListWithInactiveUsers;
              break;
            default:
              return; // Skip unknown user types
          }

          // Add filtered assignments to the target list
          filteredAssignments.forEach((user) => {
            const userItem = {
              name: user.assignedUserName,
              value: user.assignedUserName,
            };

            // Check if the item already exists in the target list
            if (
              !targetList.some(
                (item) =>
                  item.name === userItem.name && item.value === userItem.value
              )
            ) {
              targetList.push(userItem);
            }
          });
        });
      }

      this.collaboratorGroupsAndUsersList = [
        ...this.collaboratorUserListWithInactiveUsers,
      ];
      this.assignedAdminGroupsAndUsersList = [
        ...this.assignedAdminsUserListWithInactiveUsers,
      ];
      this.assignedQAsGroupsAndUsersList = [
        ...this.assignedQAsUserListWithInactiveUsers,
      ];
      this.assignedDocControlGroupsAndUsersList = [
        ...this.assignedDocControlUsersListWithInactiveUsers,
      ];
      this.internalClientContactsUsersList = [
        ...this.internalClientContactsUsersListWithInactiveUsers,
      ];
      this.reviewersList = [...this.reviewersWithInactiveUsers];
      this.approversList = [...this.approversWithInactiveUsers];
      this.periodicReviewersGroupsAndUsersList = [...this.periodicReviewersUserListWithInactiveUsers];
      this.authorList = [...this.authorWithInactiveUsers];
    }
  }

  private reassignDocumentFormWithAssignmentValues(): void {
    const assignedQAsValue = this.documentForm
      .getRawValue()
      .assignedQAs?.filter((value: string) =>
        this.assignedQAsGroupsAndUsersList.some(
          (item: any) => item.value === value
        )
      );
    this.documentForm.patchValue({ assignedQAs: assignedQAsValue });

    const assignedDocControlValue = this.documentForm
      .getRawValue()
      .assignedDocControl?.filter((value: string) =>
        this.assignedDocControlGroupsAndUsersList.some(
          (item: any) => item.value === value
        )
      );
    this.documentForm.patchValue({
      assignedDocControl: assignedDocControlValue,
    });

    const collaboratorsValue = this.documentForm
      .getRawValue()
      .collaborators?.filter((value: string) =>
        this.collaboratorGroupsAndUsersList.some(
          (item: any) => item.value === value
        )
      );
    this.documentForm.patchValue({ collaborators: collaboratorsValue });

    const assignedAdminValue = this.documentForm
      .getRawValue()
      .assignedAdmins?.filter((value: string) =>
        this.assignedAdminGroupsAndUsersList.some(
          (item: any) => item.value === value
        )
      );
    this.documentForm.patchValue({ assignedAdmins: assignedAdminValue });

    const periodicReviewersValue = this.documentForm
      .getRawValue()
      .periodicReviewers?.filter((value: string) =>
        this.periodicReviewersGroupsAndUsersList.some(
          (item: any) => item.value === value
        )
      );
    this.documentForm.patchValue({ periodicReviewers: periodicReviewersValue });
  }

  private sortAssignmentGroupList() {
    this.collaboratorGroupsAndUsersList =
      this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(
        this.collaboratorGroupsAndUsersList
      );
    this.assignedAdminGroupsAndUsersList =
      this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(
        this.assignedAdminGroupsAndUsersList
      );
    this.assignedDocControlGroupsAndUsersList =
      this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(
        this.assignedDocControlGroupsAndUsersList
      );
    this.assignedQAsGroupsAndUsersList =
      this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(
        this.assignedQAsGroupsAndUsersList
      );
    this.periodicReviewersGroupsAndUsersList =
      this.assignmentGroupSharedDataService.sortAssignmentGroupListByName(
        this.periodicReviewersGroupsAndUsersList
      );
  }

  ValidateAssignedQAsCheck() {
    if (this.isAssignedQAControlEnabled) {
      if (this.iseQMSScopeSelected) {
        this.enableControls('assignedQAs');
      } else {
        this.disableControls('assignedQAs');
      }
    } else {
      this.disableControls('assignedQAs');
    }
  }

  ValidateInternalClientContactsCheck() {
    if (this.isInternalClientContactControlEnabled) {
      if (this.documentForm.controls['convertToPdf'].getRawValue()) {
        !this.isEditSlider ||
        this.documentDetailsForEdit.phase < 3 ||
        this.documentDetailsForEdit.phase === 10
          ? this.enableControls('mergeClientSignatureAttachment')
          : this.disableControls('mergeClientSignatureAttachment');
      } else {
        this.disableControls('mergeClientSignatureAttachment');
        this.documentForm.controls['mergeClientSignatureAttachment'].setValue(
          false
        );
      }

      if (this.iseQMSScopeSelected) {
        this.enableControls('internalClientContacts');
      } else {
        this.disableControls('internalClientContacts');
      }
    } else {
      this.disableControls('mergeClientSignatureAttachment');
      this.documentForm.controls['mergeClientSignatureAttachment'].setValue(
        false
      );
      this.disableControls('internalClientContacts');
    }
  }

  ValidateConvertToPDFCheck() {
    if (
      this.documentForm.controls['convertToPdf'].getRawValue() &&
      this.documentForm.controls['includesClientSignature'].getRawValue()
    ) {
      !this.isEditSlider ||
      this.documentDetailsForEdit.phase < 3 ||
      this.documentDetailsForEdit.phase === 10
        ? this.enableControls('mergeClientSignatureAttachment')
        : this.disableControls('mergeClientSignatureAttachment');
    } else {
      this.disableControls('mergeClientSignatureAttachment');
      this.documentForm.controls['mergeClientSignatureAttachment'].setValue(
        false
      );
    }
  }

  VerifyReviewerAndApprover() {
    if (
      this.documentForm.getRawValue().approvers !== null &&
      this.documentForm.getRawValue().reviewers !== null
    )
      this.validationErrorEnable =
        this.documentForm.getRawValue().approvers.length ===
          this.documentForm.getRawValue().reviewers.length &&
        this.documentForm
          .getRawValue()
          .approvers.every((value: string) =>
            this.documentForm.getRawValue().reviewers.includes(value)
          );
  }
  CheckPeriodicReviewCycle() {
    const rawValue = this.documentForm.getRawValue();
    const periodicReviewCycle = rawValue.periodicReviewCycle;

    this.isPeriodicReviewerRequired =
      periodicReviewCycle !== null &&
      periodicReviewCycle !==
        DocumentLibraryConstants.PeriodicReviewCycle_NotApplicable_OptionValue;
    this.isPeriodicReviewCycleNull = periodicReviewCycle === null;
    this.isPeriodicReviewCycleIsNA =
      periodicReviewCycle ===
      DocumentLibraryConstants.PeriodicReviewCycle_NotApplicable_OptionValue;
    this.isPeriodicReviewCycleUserDefined =
      periodicReviewCycle ===
      DocumentLibraryConstants.PeriodicReviewCycle_UserDefined_OptionValue;
    this.disablePeriodicReviewDate =
      this.isPeriodicReviewCycleIsNA ||
      (!this.isPeriodicReviewCycleNull &&
        !this.isPeriodicReviewCycleUserDefined);

    if (!this.isPeriodicReviewerRequired) {
      this.isPeriodicReviewerMandatory = false;
    }

    this.disablePeriodicReviewDate
      ? this.disableControls('periodicReviewDate')
      : this.enableControls('periodicReviewDate');
  }

  disableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach((controlName) => {
      this.documentForm.controls[controlName].disable({ emitEvent: false });
    });
  }

  enableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach((controlName) => {
      this.documentForm.controls[controlName].enable({ emitEvent: false });
    });
  }

  ngOnDestroy() {
    this.debounceSubject.complete();
    if (this.assignmentGroupsSubscription) {
      this.assignmentGroupsSubscription.unsubscribe();
    }
    if (this.documentDetailsSubscription) {
      this.documentDetailsSubscription.unsubscribe();
    }
    if (this.loadDocumentDetailsSubscription) {
      this.loadDocumentDetailsSubscription.unsubscribe();
    }
    if (this.editDocumentSliderSubscription) {
      this.editDocumentSliderSubscription.unsubscribe();
    }
  }

  private SetForbidChangesforInReviewDocument = () => {
    let selectedScope = this.eQMSScopeList.find(
      (scope: any) =>
        scope.value === this.documentForm.getRawValue().eQMSScopes[0]
    );
    this.documentForm.controls['forbidChangesAfterInReviewTransition'].setValue(
      selectedScope.forbidChangesForInReviewDocument
    );
  };

  private SetPrintLockDocument = () => {
    let selectedScope = this.eQMSScopeList.find(
      (scope: any) =>
        scope.value === this.documentForm.getRawValue().eQMSScopes[0]
    );
    this.documentForm.controls['printLock'].setValue(
      selectedScope.printLockDocuments
    );
  };

}
